import { BaseModel } from '../base-model';

export class Site extends BaseModel {
  name: string = '';
  nom: string = '';
  nbrcab: number = 0;
  entree: string = '';
  sortie: string = '';
}
